<script lang="ts">
	import {
		getCriticalNotifications,
		getNotificationsForDevice,
	} from 'src/helpers/notifications/device_notifications_helper';
	import { device_notifications } from 'src/stores/features/device-notifications';
	import { LabelV2 } from '@Shelly/shelly-design-system/index';
	import { shouldHideLabelsAndCharts } from 'src/components/Sidepanel/device-view-state-context';

	export let deviceId: string;
	export let excludeErrors: readonly string[] = [];

	$: excludedErrorSet = new Set(excludeErrors);
	$: notificationsToShow = ($device_notifications && getNotificationsForDevice(deviceId)) || {};
	$: visibleNotifications = Object.fromEntries(
		Object.entries(notificationsToShow).filter(
			([, notification]) => !notification?.error || !excludedErrorSet.has(notification.error),
		),
	);
	$: criticalNotifications = getCriticalNotifications(visibleNotifications);
</script>

{#if deviceId && criticalNotifications?.length && !shouldHideLabelsAndCharts()}
	<div class="d-flex justify-content-center mb-s max-width-full">
		<LabelV2
			class="max-width-full"
			size="m"
			value={criticalNotifications[0].name}
			type={criticalNotifications[0].type === 'danger' ? 'danger' : 'warning'}
			icon="fa-solid fa-shield-exclamation"
			backgroundColor={criticalNotifications[0].type === 'danger'
				? '--color-danger'
				: '--color-warning'}
		/>
	</div>
{/if}
